import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LEAD_ASSIGNMENT_RULES_ACTION_TYPE } from '../actions';

const initialState = {
  rules: [],
};

const leadAssignmentRulesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LEAD_ASSIGNMENT_RULES_ACTION_TYPE.GET_RULES:
        draft.rules = payload;
        break;

      case LEAD_ASSIGNMENT_RULES_ACTION_TYPE.CREATE_RULE:
        draft.rules = [...state.rules, payload];
        break;

      case LEAD_ASSIGNMENT_RULES_ACTION_TYPE.UPDATE_RULE:
        draft.rules = state.rules.map(rule => (rule.id === payload.id ? payload : rule));
        break;

      case LEAD_ASSIGNMENT_RULES_ACTION_TYPE.DELETE_RULE:
        draft.rules = state.rules.filter(rule => rule.id !== payload);
        break;

      case LEAD_ASSIGNMENT_RULES_ACTION_TYPE.REORDER_RULES: {
        const idToOrder = {};

        payload.forEach((id, index) => {
          idToOrder[id] = index + 1;
        });

        draft.rules = state.rules
          .map(rule => ({ ...rule, order: idToOrder[rule.id] ?? rule.order }))
          .sort((a, b) => a.order - b.order);
        break;
      }

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default leadAssignmentRulesReducer;
